import React from 'react';
import { Trophy, Star, MapPin, Users } from 'lucide-react';

const VencedorDestaque = ({ vencedor, totalVotos }) => {
  if (!vencedor) return null;

  const porcentagem = totalVotos > 0 
    ? ((vencedor.votos / totalVotos) * 100).toFixed(1) 
    : 0;

  return (
    <div className="mb-8 animate-fade-in-up">
      {/* Badge "Vencedor" */}
      <div className="flex justify-center mb-4">
        <div className="bg-gradient-to-r from-yellow-400 to-amber-500 text-white px-6 py-2 rounded-full shadow-lg flex items-center gap-2">
          <Trophy className="w-5 h-5" />
          <span className="font-bold text-lg">LOCAL VENCEDOR</span>
        </div>
      </div>

      {/* Card Principal do Vencedor */}
      <div className="relative bg-gradient-to-br from-yellow-50 via-amber-50 to-yellow-100 border-4 border-yellow-400 rounded-2xl p-8 shadow-2xl overflow-hidden">
        {/* Efeitos de fundo */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-200 rounded-full opacity-20 blur-3xl -mr-32 -mt-32"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-200 rounded-full opacity-20 blur-3xl -ml-32 -mb-32"></div>
        
        {/* Conteúdo */}
        <div className="relative z-10">
          {/* Troféu animado */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <Trophy className="w-24 h-24 text-yellow-600 animate-trofeu-pular" />
              <div className="absolute inset-0 w-24 h-24 bg-yellow-400 rounded-full blur-xl opacity-50 animate-pulse"></div>
            </div>
          </div>

          {/* Nome do local vencedor */}
          <h2 className="text-4xl md:text-5xl font-black text-center text-gray-900 mb-4">
            {vencedor.nome}
          </h2>

          {/* Estatísticas do vencedor */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-6">
            <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-md">
              <Users className="w-6 h-6 text-yellow-600" />
              <span className="text-2xl font-bold text-gray-900">{vencedor.votos.toLocaleString('pt-BR')}</span>
              <span className="text-gray-600 font-medium">votos</span>
            </div>
            
            <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-md">
              <Star className="w-6 h-6 text-yellow-600" />
              <span className="text-2xl font-bold text-gray-900">{porcentagem}%</span>
              <span className="text-gray-600 font-medium">dos votos</span>
            </div>
          </div>

          {/* Mensagem de destaque */}
          <div className="bg-white/90 backdrop-blur-sm border-2 border-yellow-300 rounded-xl p-6 text-center shadow-lg">
            <MapPin className="w-8 h-8 text-yellow-600 mx-auto mb-3" />
            <p className="text-xl font-bold text-gray-900 mb-2">
              🎉 Este será o local oficial do telão!
            </p>
            <p className="text-gray-700">
              Escolhido pela maioria da população de Corumbá para assistir ao jogo do Brasil na Copa 2026.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VencedorDestaque;
